import {Injectable} from "@angular/core";
import {HttpClient} from "@angular/common/http";
import {firstValueFrom, Observable} from "rxjs";
import {environment} from "../../../../environments/environment";

@Injectable({providedIn: "root"})
export class RedirectService {
    private baseUsersEndpoint: string;

    constructor(private httpClient: HttpClient) {
        this.baseUsersEndpoint = environment.apiUser
    }

    async isRedirect(): Promise<any> {
        try {
            const redirectResponse = await firstValueFrom(this.callRedirectService());
            if (redirectResponse && redirectResponse.redirect) {
                window.location.href = redirectResponse.url;
            }
        } catch (e) {
            console.log('redirect service error')
        }
        return Promise.resolve()
    }

     callRedirectService(): Observable<any> {
        const url = `${this.baseUsersEndpoint}/redirect`;
        return this.httpClient.get(url);
    }

}
